"use client";

import React, { useState } from "react";
import { cx } from "class-variance-authority";
import Link from "next/link";
import { usePathname } from "next/navigation";
import NFT from "../../../../public/assets/process-we-follow/NFT.webp";
import CommonButton from "./CommonButton/CommonButton";

const DevelopmentFractures = ({ content }) => {
  const pathname = usePathname();
  const [active, setActive] = useState(1);

  const URLPathName = pathname.split("/")[1];

  const URLImages = {
    // Blockchain
    nfts: "/assets/process-we-follow/NFT.webp",
    evm: "/assets/process-we-follow/EVM.webp",
    marketing: "/assets/process-we-follow/Marketing.webp",
    metaverse: "/assets/process-we-follow/Metaverse.webp",
    web3: "/assets/process-we-follow/Web3.webp",
    defi: "/assets/process-we-follow/Defi.webp",
    ico: "/assets/process-we-follow/ICO.webp",
    sto: "/assets/process-we-follow/STO.webp",
    ido: "/assets/process-we-follow/IDO.webp",
    crypto: "/assets/process-we-follow/Crypto.webp",
    blockchain: "/assets/process-we-follow/Blockchain.webp",

    // Technologies
    database: "/assets/process-we-follow/Technologies.webp",
    backend: "/assets/process-we-follow/Technologies.webp",
    mobile: "/assets/process-we-follow/Technologies.webp",
    frontend: "/assets/process-we-follow/Technologies.webp",
  };

  const showingImage = URLImages[URLPathName] || NFT;

  const handleClick = (id) => {
    setActive(id);
  };

  return (
    <>
      <div className="container mx-auto mt-10 ">
        <div className="">
          <div className="text-center pt-10 pb-3 px-8 xl:px-14">
            <h3 className="text-[#FF03B8] text-3xl font-bold font-manrope mb-4">
              {content?.title1 && content?.title1}
            </h3>
            <div className="NFTFractures-border my-5" />
          </div>
        </div>

        <div className="flex flex-col xl:flex-row">
          <div className="xl:basis-1/4">
            <div className="relative">
              <div className="overflow-hidden " dir="rtl">
                <div
                  id="style-7"
                  className="flex-none min-w-full   overflow-auto max-h-96 md:px-0 lg:max-h-96"
                >
                  {content?.services?.map((item, ind) => (
                    <ul
                      dir="ltr"
                      className=""
                      key={item?.id || ind}
                    >
                      <li
                        onClick={() =>
                          handleClick(item?.id)
                        }
                        className={cx(
                          "pl-6 h-16 w-full flex items-center text-base hover:bg-[#410ead]/10 cursor-pointer whitespace-nowrap",
                          active === item?.id
                            ? "text-[#410ead] bg-[#410ead]/20 !font-bold"
                            : "NFTFractures-border font-normal"
                        )}
                      >
                        {` > ${item?.title && item?.title}`}
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* if ui-ux in URL */}
          {URLPathName == "ui-ux" ? (
            <div className="xl:basis-3/4 ">
              {content?.services?.map((item, ind) => (
                <div key={item?.id || ind}>
                  {active === item?.id && (
                    <div
                      id="style-7"
                      className="bg-cover lg:h-96  p-4 lg:py-5 lg:px-12  bg-center overflow-hidden"
                      style={{
                        background: `url(/assets/process-we-follow/Technologies.webp) no-repeat `,
                        backgroundSize: "cover",
                        height: "386px", 
                      }}
                    >
                      <div className="fadeInDown">
                        <h3 className=" my-4 text-white text-xl font-semibold font-manrope ">
                          {item?.title && item?.title}
                        </h3>
                        <p className=" text-[#D6D6D6] font-normal text-lg max-w-lg text-start">
                          {item?.description &&
                            item?.description}
                        </p>

                        {item?.buttonClick && (
                          <Link href={item.buttonClick} className="common-white-button-style mt-4 font-bold inline-block">
                            {item.buttonName}<span className="sr-only"> about contacting TanThetaa</span>
                          </Link>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="xl:basis-3/4 ">
              {content?.services?.map((item, ind) => (
                <div key={item?.id || ind}>
                  {active === item?.id && (
                    <div
                      id="style-7"
                      className="bg-cover lg:h-96  p-4 lg:py-5 lg:px-12  bg-center overflow-hidden"
                      style={{
                        background: `url(${showingImage}) no-repeat `,
                        backgroundSize: "cover",
                        height: "386px", // Corrected the style here
                      }}
                    >
                      <div className="fadeInDown">
                        <h3 className=" my-4 text-white text-xl font-semibold font-manrope ">
                          {item?.title && item?.title}
                        </h3>
                        <p className=" text-[#D6D6D6] font-normal text-lg max-w-lg text-start">
                          {item?.description &&
                            item?.description}
                        </p>
                        {item?.buttonName && (
                          <CommonButton
                            name={item?.buttonName}
                            href={item?.buttonClick}
                            className="common-white-button-style mt-4 font-bold w-fit"
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DevelopmentFractures;
